<div class="project-card">
  <ng-container *ngIf="store.projectChanged$ | async as project; else noSelectedProject">
    <span  class="project-card-client">{{ project.name }}  <ng-container *ngIf="project.actionsCount"> ({{ project.actionsCount }})</ng-container></span>
    <button *ngIf="!disabled" mat-button (click)="changeProject()" class="project-card-btn">{{ 'CHANGE_PROJECT' | translate }}</button>
  </ng-container>

  <ng-template #noSelectedProject>
    {{ 'NO_SELECTED_PROJECT' | translate }}
    <button *ngIf="!disabled" mat-button (click)="changeProject()" class="project-card-btn">{{ 'SELECT_PROJECT' | translate }}</button>
  </ng-template>
</div>
